import {
  FETCH_CONTAINER_YARDS,
  FETCH_CONTAINER_YARDS_SUCCESS,
  FETCH_CONTAINER_YARDS_FAILED,
  EDIT_CONTAINER_YARD
} from "../store/types";

const INITIAL_STATE = {
  yards: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const containeryardreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONTAINER_YARDS:
      return {
        ...state,
        loading: true
      };
    case FETCH_CONTAINER_YARDS_SUCCESS:
      return {
        ...state,
        yards: action.payload,
        loading: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_CONTAINER_YARDS_FAILED:
      return {
        ...state,
        yards: [],
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_CONTAINER_YARD:
      return state;
    default:
      return state;
  }
};
